import { render } from "./FeaturedImagesPreview.vue?vue&type=template&id=5f73e70e&scoped=true"
import script from "./FeaturedImagesPreview.vue?vue&type=script&lang=js"
export * from "./FeaturedImagesPreview.vue?vue&type=script&lang=js"

import "./FeaturedImagesPreview.vue?vue&type=style&index=0&id=5f73e70e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f73e70e"]])

export default __exports__